import { DATA } from "./data/store.js";

// Uygulama durumu. Kök modüldür — domain katmanına bağlanmaz,
// aksi hâlde context.js ile döngü kurulur.
export const state = {
  // Kiracılık: hangi müşteri kurum, o kurumun hangi şubesi.
  //
  // Açılışta BOŞ. Depo (data/store.js) veriyi demo tohumundan ya da
  // Firestore'dan aldıktan sonra kapsamiKur() ile doldurulur. Eskiden
  // burada DATA.tenants[0] okunuyordu; depo boş başlayınca bu modül
  // yüklenirken patlıyordu ve daha kötüsü, gerçek modda kullanıcıyı
  // demo kiracısına sabitliyordu.
  tenantId: null,
  branchId: null,

  view: "panel",
  studentQuery: "",
  studentClass: "all",
  activeThread: null,
  payFilter: "all",
  attendanceTab: "gunluk",
  finansTab: "ozet",
  sistemTab: "ozet",
  notifOpen: false,
  odemeTab: "faturalar",
  mesajTab: "yazismalar",
  classId: null,
  staffId: null,
  photoDraft: null,
  photoError: null,
};

/**
 * Depo dolduktan sonra ilk kapsamı kurar.
 * Verilen kiracı yoksa (veya verilmediyse) ilk kiracıya düşer.
 */
export function kapsamiKur(tenantId = null) {
  const kiraci = DATA.tenants.find(t => t.id === tenantId) ?? DATA.tenants[0] ?? null;
  state.tenantId = kiraci?.id ?? null;
  state.branchId = kiraci?.branches?.[0]?.id ?? null;
  return Boolean(kiraci);
}

/** Kiracı değişince şube de o kiracının ilk şubesine döner. */
export function kiraciSec(tenantId) {
  const kiraci = DATA.tenants.find(t => t.id === tenantId);
  if (!kiraci) return false;
  state.tenantId = kiraci.id;
  state.branchId = kiraci.branches[0]?.id ?? null;
  state.classId = null;
  state.staffId = null;
  state.activeThread = null;
  return true;
}
